import { apiClient } from './client';

// round7 §1-7 (D9) — 셀프 체크 위저드 로그 열람(ADMIN).
//   GET /admin/self-check-logs?category=&resolved=&serial=&page=&pageSize=

export type SelfCheckCategory = 'NOT_WORKING' | 'GRILL_ISSUE' | 'SELECTOR' | 'OTHER';

export interface SelfCheckPathEntry {
  nodeId: string;
  question: string;
  answer: string;
}

export interface SelfCheckLogDto {
  id: string;
  serial: string | null;
  category: string;
  path: SelfCheckPathEntry[];
  resolved: boolean;
  createdAt: string;
}

export interface ListSelfCheckQuery {
  category?: SelfCheckCategory;
  resolved?: boolean;
  serial?: string;
  page?: number;
  pageSize?: number;
}

export interface ListSelfCheckResponse {
  items: SelfCheckLogDto[];
  page: number;
  pageSize: number;
  total: number;
}

export const selfCheckApi = {
  async list(query: ListSelfCheckQuery = {}): Promise<ListSelfCheckResponse> {
    const { data } = await apiClient.get<ListSelfCheckResponse>('/admin/self-check-logs', {
      params: query,
    });
    return data;
  },
};
